import { p as proxyCustomElement, H, h, a as Host } from './index.js';

const progressBarCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;box-sizing:border-box;display:flex;font-family:Open Sans;font-size:.875rem;font-weight:400;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal;width:100%}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}:host([type=linear]){background-color:var(--jw-theme-neutral-muted-message-bg-color);border-radius:624.9375rem;height:.5rem;overflow:hidden;position:relative}:host([type=linear]) .linear-fill{border-radius:624.9375rem;height:.5rem;transition:width .2s ease-in-out;width:100%}:host([type=linear]) .linear-fill.regular{background-color:var(--jw-theme-system-primary-default-bg-color)}:host([type=linear]) .linear-fill.warning{background-color:var(--jw-theme-warning-primary-default-bg-color)}:host([type=linear]) .linear-fill.error{background-color:var(--jw-theme-error-primary-default-bg-color)}:host([type=linear][indeterminate]) .linear-fill{animation:ucjdous 1.3s linear infinite alternate;height:.5rem;position:absolute;transition:none;width:30%}@keyframes ucjdous{0%{left:0}to{left:70%}}:host([type=circular]){height:24px;width:24px}:host([type=circular]) .circle-background{stroke:var(--jw-theme-neutral-muted-message-bg-color)}:host([type=circular]) .circle-background,:host([type=circular]) .circle-progress{fill:none}:host([type=circular]) .circle-progress{transition:all .2s ease-in-out;stroke-linecap:round;stroke-linejoin:round}:host([type=circular]) .circle-progress.regular{stroke:var(--jw-theme-system-primary-default-bg-color)}:host([type=circular]) .circle-progress.warning{stroke:var(--jw-theme-warning-primary-default-bg-color)}:host([type=circular]) .circle-progress.error{stroke:var(--jw-theme-error-primary-default-bg-color)}:host([type=circular][indeterminate]) svg{animation:ucjdovf 1.5s linear infinite}@keyframes ucjdovf{to{transform:rotate(1turn)}}:host([type=circular][indeterminate]) svg .circle-progress{animation:ucjdowd 2s ease-in-out infinite}@keyframes ucjdowd{0%{stroke-dasharray:1,150;stroke-dashoffset:0}50%{stroke-dasharray:90,150;stroke-dashoffset:-45}to{stroke-dasharray:90,150;stroke-dashoffset:-60}}";

const WuiProgressBar = /*@__PURE__*/ proxyCustomElement(class WuiProgressBar extends H {
    constructor(registerHost) {
        super();
        if (registerHost !== false) {
            this.__registerHost();
        }
        this.__attachShadow();
        /**
         * Determines bar or circular form
         */
        this.type = 'linear';
        /**
         * Progressvalue 0-1
         */
        this.progressValue = 0;
        /**
         * If progress value is unknown
         */
        this.indeterminate = false;
        /**
         * Progress bar background color
         */
        this.progressBackground = 'regular';
        this.getSvgProperties = (percentage) => {
            const sqSize = 24;
            const strokeWidth = 4;
            const radius = (sqSize - strokeWidth) / 2;
            const viewBox = `0 0 ${sqSize} ${sqSize}`;
            const dashArray = radius * Math.PI * 2;
            const dashOffset = dashArray - (dashArray * percentage) / 100;
            const resetOffset = percentage <= 10 ? dashOffset : dashOffset + strokeWidth / 2;
            return {
                sqSize,
                strokeWidth,
                radius,
                viewBox,
                dashArray,
                resetOffset,
            };
        };
    }
    render() {
        let progressValue = typeof this.progressValue === 'undefined' ? 0 : this.progressValue;
        // Sanity check
        if (progressValue > 1) {
            progressValue = 1;
        }
        const percentage = Math.round(progressValue * 100);
        const width = !this.indeterminate ? { width: `${percentage}%` } : undefined;
        const { sqSize, viewBox, radius, strokeWidth, dashArray, resetOffset } = this.getSvgProperties(percentage);
        return (h(Host, { key: '9f8998c87e9d040940a0ec5f4ad8f207f172ab89' }, this.type === 'circular' && (h("svg", { key: '755747e5514c471231ad2612e9f9abf2ef9f77d6', height: sqSize, viewBox: viewBox }, h("title", { key: '9ec3d26d2e1f0e3a27b498dccf23fe6abbbea25d' }, "Progress indicator"), h("circle", { key: '4e258e12b3d3444e248b5d18da2fc4d59976392a', class: "circle-background", cx: sqSize / 2, cy: sqSize / 2, r: radius, "stroke-width": `${strokeWidth}px` }), h("circle", { key: 'b09a3ee84e5d6e91385b79f93ac882e1e71133c2', class: ['circle-progress', this.progressBackground].filter(Boolean).join(' '), cx: sqSize / 2, cy: sqSize / 2, r: radius, "stroke-width": `${strokeWidth}px`, transform: `rotate(${ -90 + strokeWidth} ${sqSize / 2} ${sqSize / 2})`, style: { strokeDasharray: `${dashArray}`, strokeDashoffset: `${resetOffset}` } }))), this.type === 'linear' && (h("div", { key: '8b13c2f55b411bc3dbbec790d6c2ef3fac6b5262', class: ['linear-fill', this.progressBackground].filter(Boolean).join(' '), style: width }))));
    }
    static get style() { return progressBarCss; }
}, [257, "wui-progress-bar", {
        "type": [513],
        "progressValue": [2, "progress-value"],
        "indeterminate": [516],
        "progressBackground": [513, "progress-background"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-progress-bar"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-progress-bar":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiProgressBar);
            }
            break;
    } });
}
defineCustomElement();

export { WuiProgressBar as W, defineCustomElement as d };
